import { useTranslation } from "react-i18next";

import Cell from "../../components/common/AccordionTable/components/Cell";
import DropdownItem from "../../components/common/AccordionTable/components/DropdownTableMenu/components/DropdownItem";

export const useBrowserInfoAdapter = () => {
  const { t } = useTranslation();

  const headerData = [
    t("browserInfo.columnType"),
    t("browserInfo.columnDiscovered"),
    t("browserInfo.columnCookie"),
  ];

  const getValue = result => {
    return result === "N/A" || result === "" ? "-" : result;
  };

  const getStatus = result => {
    return result === "N/A" || result === "" ? t("global.no") : t("global.yes");
  };

  const renderRowContent = item => {
    const value = getValue(item.result);
    const status = getStatus(item.result);

    return (
      <>
        <Cell>{item.name}</Cell>
        <Cell>{status}</Cell>
        <Cell>{value}</Cell>
      </>
    );
  };

  const renderHeaderTitle = item => {
    return item.name;
  };

  const renderDropdownContent = item => {
    const value = getValue(item.result);
    const status = getStatus(item.result);

    return (
      <>
        <DropdownItem>
          <span>{headerData[1]}</span> {status}
        </DropdownItem>

        <DropdownItem>
          <span>{headerData[headerData.length - 1]} </span>
          {value}
        </DropdownItem>
      </>
    );
  };

  return {
    headerData,
    renderRowContent,
    renderDropdownContent,
    renderHeaderTitle,
  };
};
